export const ICON_LIST = [
	{
		src: "https://dealerportal.mysunglow.com/images/icons/eco-friendly-icon.png",
		title: "Eco-friendly",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/antimicrobial-icon.png",
		title: "Anti-microbial",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/fire-resist-icon.png",
		title: "Fire-resistant",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/graphic-shades-icon.png",
		title: "Graphic Shade Compatible",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/rail_road-icon.png",
		title: "Rail Road Option",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/matching-set-icon.png",
		title: "Part of a Set",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/reflective_icon.png",
		title: "Reflective",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/sound-absorption-icon.png",
		title: "Sound Absorption",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/ultrasonic-icon.png",
		title: "Ultrasonic",
	},
	{
		src: "https://dealerportal.mysunglow.com/images/icons/cold-crush-icon.png",
		title: "Cold/Crush Cut",
	},
];

export const FABRIC_TYPES = [
	{
		icon: "https://dealerportal.mysunglow.com/images/icons/roller-shade-icon.png",
		title: "Roller",
		items: [
			"Roller Shades",
			"Vision Shades",
			"Panel Track",
			"Atlas Bottom Up Shades",
			"Fixed Shades",
			"Nimbus Skylight Shades",
			"Dual Shades",
		],
	},
	{
		icon: "https://dealerportal.mysunglow.com/images/icons/interlude-icon.png",
		title: "Interlude",
		items: ["Interlude", "Dual Shades", "Fixed Shades"],
	},
	{
		icon: "https://dealerportal.mysunglow.com/images/icons/illusions-icon.png",
		title: "Illusions",
		items: ["Illusions", "Dual Shades", "Fixed Shades"],
	},
];

export const SHADE_ICONS = {
	roller: {
		title:
			"Compatible with Roller Shades, Vision Shades, Panel Track, Atlas Bottom Up Shades, Fixed Shades, Nimbus Skylight Shades, Dual Shades",
		src: "https://dealerportal.mysunglow.com/images/icons/roller-shade-icon.png",
		alt: "Roller Shade Compatible",
	},
	interlude: {
		title: "Compatible with Interlude Shades, Dual Shades, Fixed Shades",
		src: "https://dealerportal.mysunglow.com/images/icons/interlude-icon.png",
		alt: "Interlude Shade Compatible",
	},
	illusion: {
		title: "Compatible with Illusions, Dual Shades, Fixed Shades",
		src: "https://dealerportal.mysunglow.com/images/icons/illusions-icon.png",
		alt: "Illusions Compatible",
	},
	"Simply Cellular": {
		title: "Simply Cellular Shade Compatible",
		src: "https://dealerportal.mysunglow.com/images/icons/cellular.png",
		alt: "Simply Cellular Shade Compatible",
	},
};

export const CUTTING_ICONS = {
	ultrasonic: {
		title: "Ultrasonic",
		src: "https://dealerportal.mysunglow.com/images/icons/ultrasonic-icon.png",
		alt: "Ultrasonic",
	},
	coldCrush: {
		title: "Cold/Crush Cut",
		src: "https://dealerportal.mysunglow.com/images/icons/cold-crush-icon.png",
		alt: "Cold/Crush Cut",
	},
};
